import { kpRequest, kpEndpoint, kpParams } from '@/axios'

export const CONFIRMED_ORDERS = 'confirmedOrders'
export const ACTIVE_ORDERS = 'activeOrders'
export const DOWNLOAD_ORDER_INVOICE = 'downloadOrderInvoice'
export const GET_ORDER = 'getOrder'
export const ORDER_IMPORT = 'orderImport'
export const UPDATE_ORDER_PRODUCT_STATUS = 'updateOrderProductStatus'
export const UPDATE_ORDER = 'updateOrder'
export const MODIFY_ORDER_PRODUCTS = 'modifyOrderProducts'
export const MODIFY_ORDER_QUANTITIES = 'modifyOrderQuantities'
export const GET_ORDER_LIST = 'getOrderList'
export const GET_ORDER_FILTER_OPTIONS = 'getOrderFilterOptions'
export const CREATE_ORDER = 'createOrder'
export const APPROVE_ORDER = 'approveOrder'
export const CONFIRM_ORDER_PRODUCTS = 'confirmOrderProducts'
export const ACCEPT_ORDER_MODIFICATIONS = 'acceptOrderModifications'
export const CANCEL_ORDER_MODIFICATIONS = 'cancelOrderModifications'
export const REJECT_ORDER = 'rejectOrder'
export const CANCEL_ORDER = 'cancelOrder'
export const CHECK_ORDER_INSTOCK = 'checkOrderInstock'
export const REVERT_ORDER_TO_ACCEPTED = 'revertOrderToAccepted'
export const ADD_ORDER_PRODUCTS = 'addOrderProducts'
export const DOWNLOAD_ORDER = 'downloadOrder'
export const ORDER_PRODUCTION_FILE_EXPORT = 'orderProductionFileExport'
export const CREATE_MULTIPLE_ORDER = 'createMultipleOrder'
export const GET_ORDERS_INFO_BY_COLLECTION_ID_AND_CURRENCY = 'getOrdersInfoByCollectionIdAndCurrency'
export const GET_ORDERS_BY_COLLECTION_SEQ_IDS = 'getOrdersByCollectionSeqIds'
export const UPDATE_ORDER_PRODUCTS_DISCOUNT = 'updateOrderProductsDiscount'
export const EXPORT_ORDER_FOR_MODIFY = 'exportOrderForModify'
export const IMPORT_ORDER_FOR_MODIFY = 'importOrderForModify'
export const GET_BULK_SHIP_PRODUCTS = 'getBulkShipProducts'
export const GET_BULK_SHIP_ELIGIBLE_ORDERS = 'getBulkShipEligibleOrders'

const actions = {
  async [UPDATE_ORDER](ctx, { orderId, payload = {} }) {
    return await kpRequest({ ...kpParams(kpEndpoint.order.patch, orderId), payload })
  },
  async [CONFIRMED_ORDERS](ctx, collectionId) {
    const params = {
      collectionId,
      confirmedOrders: true,
    }
    return await kpRequest({ ...kpEndpoint.order.get, params })
  },
  async [ACTIVE_ORDERS](ctx, collectionId) {
    return await kpRequest({ ...kpParams(kpEndpoint.order.activeSeqIds, collectionId) })
  },
  async [DOWNLOAD_ORDER_INVOICE](ctx, orderId) {
    return await kpRequest(
      {
      ...kpParams(kpEndpoint.order.downloadInvoice, orderId),
      ...{
        responseType: 'blob',
        headers: {
          Accept: 'application/pdf',
        },
      },
     },
    )
  },
  async [GET_ORDER](ctx, orderId) {
    return await kpRequest({ ...kpParams(kpEndpoint.order.getById, orderId) })
  },
  async [MODIFY_ORDER_PRODUCTS](ctx, { orderId, params = {}, payload = {} }) {
    return await kpRequest({ ...kpParams(kpEndpoint.order.modify, orderId), payload, params })
  },
  async [MODIFY_ORDER_QUANTITIES](ctx, { orderId, payload = {} }) {
    return await kpRequest({ ...kpParams(kpEndpoint.order.modifyQuantities, orderId), payload })
  },
  async [ORDER_IMPORT](ctx, { orderId, payload = {} }) {
    return await kpRequest({ ...kpParams(kpEndpoint.order.import, orderId), payload })
  },
  async [UPDATE_ORDER_PRODUCT_STATUS](ctx, { orderId, payload = {} }) {
    return await kpRequest({ ...kpParams(kpEndpoint.order.updateProductStatus, orderId), payload })
  },
  async [GET_ORDER_LIST](ctx, params = {}) {
    return await kpRequest({ ...kpEndpoint.order.get, params })
  },
  async [GET_ORDER_FILTER_OPTIONS](ctx, { searchField, params = {} }) {
    return await kpRequest({ ...kpParams(kpEndpoint.order.filterByFieldName, searchField), params })
  },
  async [CREATE_ORDER](ctx, payload = { }) {
    return await kpRequest({ ...kpEndpoint.order.create, payload })
  },
  async [CREATE_MULTIPLE_ORDER](ctx, payload = { }) {
    return await kpRequest({ ...kpEndpoint.order.createMultiple, payload })
  },
  async [APPROVE_ORDER](ctx, orderId) {
    return await kpRequest({ ...kpParams(kpEndpoint.order.approve, orderId) })
  },
  async [CONFIRM_ORDER_PRODUCTS](ctx, { orderId, payload = {} }) {
    return await kpRequest({ ...kpParams(kpEndpoint.order.confirmProducts, orderId), payload })
  },
  async [ACCEPT_ORDER_MODIFICATIONS](ctx, orderId) {
    return await kpRequest({ ...kpParams(kpEndpoint.order.acceptModifications, orderId) })
  },
  async [CANCEL_ORDER_MODIFICATIONS](ctx, orderId) {
    return await kpRequest({ ...kpParams(kpEndpoint.order.cancelModifications, orderId) })
  },
  async [REJECT_ORDER](ctx, orderId) {
    return await kpRequest({ ...kpParams(kpEndpoint.order.reject, orderId) })
  },
  async [CANCEL_ORDER](ctx, { orderId, params = {} }) {
    return await kpRequest({ ...kpParams(kpEndpoint.order.cancel, orderId), params })
  },
  async [CHECK_ORDER_INSTOCK](ctx, orderId) {
    return await kpRequest({ ...kpParams(kpEndpoint.order.isInstock, orderId) })
  },
  async [REVERT_ORDER_TO_ACCEPTED](ctx, orderId) {
    return await kpRequest({ ...kpParams(kpEndpoint.order.revertToAccepted, orderId) })
  },
  async [ADD_ORDER_PRODUCTS](ctx, { orderId, payload }) {
    return await kpRequest({ ...kpParams(kpEndpoint.order.addOrderProducts, orderId), payload })
  },
  async [DOWNLOAD_ORDER](ctx, { payload = {}, params = {} }) {
    return await kpRequest({ ...kpEndpoint.downloads.order, params, payload })
  },
  async [ORDER_PRODUCTION_FILE_EXPORT](ctx, params = {}) {
    return await kpRequest({ ...kpEndpoint.order.productionExport, params })
  },
  async [GET_ORDERS_INFO_BY_COLLECTION_ID_AND_CURRENCY](ctx, payload) {
    const { currencies, collectionId } = payload
    return await kpRequest({ ...kpParams(kpEndpoint.order.getOrderByCollectionIdAndCurrency, collectionId), payload: { currencies } })
  },
  async [GET_ORDERS_BY_COLLECTION_SEQ_IDS](ctx, collectionId) {
    return await kpRequest({ ...kpParams(kpEndpoint.order.getOrdersByCollectionSeqIds, collectionId) })
  },
  async [UPDATE_ORDER_PRODUCTS_DISCOUNT](ctx, { orderId, payload = {} }) {
    return await kpRequest({ ...kpParams(kpEndpoint.order.updateProductsDiscount, orderId), payload })
  },
  async [EXPORT_ORDER_FOR_MODIFY](ctx, { payload = {} }) {
    return await kpRequest({ ...kpEndpoint.downloads.orderProducts, payload })
  },
  async [IMPORT_ORDER_FOR_MODIFY](ctx, { orderId, payload = {} }) {
    return await kpRequest({
      ...kpParams(kpEndpoint.order.importForModify, orderId),
      payload,
    })
  },
  async [GET_BULK_SHIP_PRODUCTS](ctx, params = {}) {
    return await kpRequest({ ...kpEndpoint.order.bulkShipProducts, params })
  },
  async [GET_BULK_SHIP_ELIGIBLE_ORDERS](ctx, payload = {}) {
    return await kpRequest({ ...kpEndpoint.order.bulkShipEligible, payload })
  },
}

export default {
  actions,
}
